import './assets/scss/app.scss'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './i18n'
import './components'
import './filters'
import './plugins'

import { sync } from 'vuex-router-sync'
sync(store, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    ...App,
    template: '<App/>'
})

/**
 * @TODO
 *  - Pörgőforgó betöltő amíg a tábla nem jelenik meg
 *  - Kép kattintásra jöjjön fel
 *  - Artist kategóriák és hozzárendelő az artistokba
 *  - Wishlist
 *  - Excel import időpont parser fix
 */


// WEBPACK FOOTER //
// ./src/main.js